import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "store-item" }
const _hoisted_2 = { class: "coins" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["disabled"]

import StoreItemDTO from "@/models/StoreItemDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {computed} from "vue";
import StoreCoinsDTO from "@/models/StoreCoinsDTO";
import {useStore} from "vuex";
import { AppEvents } from "@/models/enum/AppEvents";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'CoinsBundle',
  props: {
    item: {},
    buyBtnDisabled: { type: Boolean }
  },
  emits: ['buy'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const store = useStore();
const router = useRouter();

const emit = __emit

const buy = () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  store.dispatch('emit', {event: AppEvents.BUY_ITEM, data: props.item})
  emit('buy', props.item)
}
const coins = computed(() => {
  return props.item.content as StoreCoinsDTO
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(coins.value.sum)), 1)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "bonus",
      style: {"display":"none"}
    }, [
      _createElementVNode("span", null, "50% Bonus")
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: coins.value.iconUrl
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("button", {
      disabled: _ctx.buyBtnDisabled,
      onClick: _withModifiers(buy, ["prevent"]),
      class: "btn btn-primary w-100"
    }, _toDisplayString(_unref(numberFormatter).formatMoney(_ctx.item.price)), 9, _hoisted_5),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subtext" }, [
      _createElementVNode("span", null, "One time offer")
    ], -1))
  ]))
}
}

})